import { getExpressionParser } from '../../modules/expressionParser';
import { tz as momentTz } from 'moment-timezone';
export const createNowParser = () => {
    const expressionParser = getExpressionParser();
    const parse = async (data) => {
        let value = '';
        if (data.data.format === 'Custom') {
            value = momentTz(data.data.timezone).format((await expressionParser.parse(data.data.customFormat, 'strip')).value);
        }
        else {
            value = momentTz(data.data.timezone).format(data.data.format);
        }
        return {
            value,
            isPlainText: true
        };
    };
    return {
        parse
    };
};
